import { Box, CircularProgress, Icon, Typography } from '@mui/material'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import React from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { redundantResume } from 'services/api/modules/recruitment/external-talent'

const RedundantTalent = () => {
  const navigate = useNavigate()

  const { data, isLoading } = useQuery(
    'getRedundant',
    async () => {
      const { data } = await redundantResume()
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const redundantCount = data?.redundant_count
  const redundantCandidates = data?.redundant_candidateable

  return (
    <DashboardContainer>
      <Box sx={{ paddingBottom: '35px' }}>
        <Box
          sx={{
            color: 'light-gray-text.main',
            display: 'flex',
            justifyContent: 'space-between',
            padding: '14px 14px 14px 0',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Typography
              onClick={() => navigate('/app/recruitment/external-talent')}
              sx={{ color: 'alternate.main', cursor: 'pointer' }}
            >
              External talents
            </Typography>
            <Icon sx={{ color: 'light-gray-text-2.main', fontSize: '20px' }}>chevron_right</Icon>
            <Typography>Redundant talents{redundantCount ? ` (${redundantCount})` : ''}</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            padding: '12px 16px',
            marginBottom: '16px',
            borderRadius: '2px',
            borderLeft: '3px solid #F3BF3A',
            backgroundColor: 'light-warning.main',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Icon sx={{ color: 'warning.main' }}>error</Icon>
            <Typography>Keep one talent per email to resolve redundancy</Typography>
          </Box>
        </Box>
        {isLoading ? (
          <Box
            sx={{
              height: '50vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress color="alternate" />
          </Box>
        ) : (
          <Box sx={{ borderRadius: '4.5px', overflow: 'clip' }}>
            {redundantCandidates?.map((item, index) => (
              <Box
                key={index}
                onClick={() =>
                  navigate(`/app/recruitment/external-talent/redundant/${index + 1}`, {
                    state: {
                      redundantEmail: item.email,
                    },
                  })
                }
                sx={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '24px 16px',
                  backgroundColor: 'white.main',
                  borderTop: index === 0 ? 'none' : '1px solid #E5E5E5',
                }}
              >
                <Box sx={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
                  <Icon sx={{ color: 'warning.main' }}>error</Icon>
                  <Typography>{item.total} talents with the same email found</Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '50%',
                  }}
                >
                  <Typography sx={{ color: 'light-gray-text.main' }}>{item.email}</Typography>
                  <Icon>chevron_right</Icon>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </DashboardContainer>
  )
}

export default RedundantTalent
